(() => {
  const LETTER_SIZE_ORDER = [
    'XXXS',
    'XXS',
    'XS',
    'S',
    'M',
    'L',
    'XL',
    'XXL',
    '2XL',
    'XXXL',
    '3XL',
    '4XL',
    '5XL',
    '6XL'
  ];

  const parseSizeValue = (label) => {
    const text = (label || '').trim();
    const normalized = text.replace(',', '.');
    const isPureNumeric = /^-?\d+(?:\.\d+)?$/.test(normalized);
    const numericValue = Number.parseFloat(normalized);

    if (isPureNumeric && !Number.isNaN(numericValue)) {
      return { type: 'numeric', value: numericValue };
    }

    const upperText = text.toUpperCase();
    const numericXlMatch = upperText.match(/^(\d+)XL$/);
    if (numericXlMatch) {
      return { type: 'letter', value: 5 + parseInt(numericXlMatch[1], 10) };
    }

    const letterIndex = LETTER_SIZE_ORDER.indexOf(upperText);
    if (letterIndex !== -1) {
      return { type: 'letter', value: letterIndex };
    }

    return { type: 'text', value: text.toLowerCase() };
  };

  const compareSizeValues = (left, right) => {
    const leftValue = parseSizeValue(left);
    const rightValue = parseSizeValue(right);
    const typeOrder = { numeric: 0, letter: 1, text: 2 };

    if (leftValue.type !== rightValue.type) {
      return typeOrder[leftValue.type] - typeOrder[rightValue.type];
    }

    if (leftValue.type === 'numeric' || leftValue.type === 'letter') {
      return leftValue.value - rightValue.value;
    }

    return leftValue.value.localeCompare(rightValue.value, undefined, {
      numeric: true
    });
  };


  const getInputLabel = (input, container) => {
    if (input?.value) return input.value;

    const label = container?.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    return label?.textContent?.trim() || '';
  };

  const sortCardFieldset = (fieldset) => {
    const items = [...fieldset.querySelectorAll(':scope > .button--variant')];
    if (items.length < 2) return;

    items.sort((leftItem, rightItem) => {
      const leftLabel = getInputLabel(leftItem.querySelector('input'), leftItem);
      const rightLabel = getInputLabel(rightItem.querySelector('input'), rightItem);
      return compareSizeValues(leftLabel, rightLabel);
    });

    items.forEach((item) => {
      item.classList.remove('hidden');
      item.classList.remove('product-card__variant--overflow');
      fieldset.appendChild(item);
    });

    const moreIndicator = fieldset.querySelector('.product-card__variants--more');
    if (moreIndicator) {
      fieldset.appendChild(moreIndicator);
    }
  };

  const sortProductFieldset = (fieldset) => {
    const inputs = [...fieldset.querySelectorAll(':scope > input[type="radio"]')];
    if (inputs.length < 2) return;

    inputs.sort((leftInput, rightInput) =>
      compareSizeValues(
        getInputLabel(leftInput, fieldset),
        getInputLabel(rightInput, fieldset)
      )
    );

    inputs.forEach((input) => {
      const label = fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      fieldset.appendChild(input);
      if (label) fieldset.appendChild(label);
    });
  };

  const sortDropdown = (container) => {
    const select = container.querySelector('select');
    if (!select) return;

    const options = [...select.querySelectorAll('option')];
    options.sort((leftOption, rightOption) =>
      compareSizeValues(leftOption.value, rightOption.value)
    );
    options.forEach((option) => select.appendChild(option));
  };

  const sortContainer = (root = document) => {
    root.querySelectorAll('.js-product-card-options').forEach((fieldset) => {
      sortCardFieldset(fieldset);
    });

    root.querySelectorAll('[data-option-sort="size-asc"]').forEach((sortable) => {
      if (sortable.classList.contains('js-product-card-options')) return;

      if (sortable.tagName === 'FIELDSET') {
        sortProductFieldset(sortable);
        return;
      }

      sortDropdown(sortable);
    });
  };

  const sortFacetLists = (root = document) => {
    root.querySelectorAll('.js-filter[data-facet-sort="size-asc"] .facets__list').forEach((list) => {
      const items = Array.from(list.querySelectorAll('.facets__item'));

      items.sort((leftItem, rightItem) => {
        const leftLabel = leftItem.querySelector('label')?.textContent || '';
        const rightLabel = rightItem.querySelector('label')?.textContent || '';
        return compareSizeValues(leftLabel, rightLabel);
      });

      items.forEach((item) => list.appendChild(item));
    });
  };

  const sortAll = (root = document) => {
    sortContainer(root);
    sortFacetLists(root);
  };

  const scheduleSort = (root = document) => {
    requestAnimationFrame(() => sortAll(root));
    requestAnimationFrame(() => {
      requestAnimationFrame(() => sortAll(root));
    });
  };

  window.SortSizeOptions = {
    sortAll,
    sortContainer,
    sortFacetLists,
    scheduleSort,
    compareSizeValues
  };

  document.addEventListener('DOMContentLoaded', () => scheduleSort());
})();
